import { render, staticRenderFns } from "./PatreonAuth.vue?vue&type=template&id=bc53155e&scoped=true"
import script from "./PatreonAuth.vue?vue&type=script&lang=js"
export * from "./PatreonAuth.vue?vue&type=script&lang=js"
import style0 from "./PatreonAuth.vue?vue&type=style&index=0&id=bc53155e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc53155e",
  null
  
)

export default component.exports